'use client';

import { useContactForm } from './useContactForm';
import { ContactFormWebApiData } from './ContactForm.types';
import { translateInline } from '@/globals/translate/translateInline';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { callToActionBox } from '@/uiComposites/interactive/callToAction';
import { textBlock } from '@/uiPrimitives/typography/text';
import { addTestSelector } from '@dop/shared/helpers/testSelector';

export const PreviewButton = ({
	fieldsets,
}: {
	fieldsets: ContactFormWebApiData['form']['fieldsets'];
}) => {
	const [contactFormState, dispatch] = useContactForm();
	const formIsInvalid = Object.values(contactFormState?.fields ?? {}).some(
		(field) => field.isDirty && field.isTouched && !field?.isValid,
	);

	return (
		<button
			type="button"
			{...addTestSelector('uiContactFormPreviewBtn')}
			className={classes(
				callToActionBox({
					box: {
						backgroundColor: formIsInvalid ? 'positiveRed' : 'positiveBlue',
					},
				}),
			)}
			onClick={() => {
				dispatch({ type: 'previewContactForm', fieldsets });
			}}
		>
			<span className={classes(textBlock({}))}>
				{translateInline({
					en: 'Verify your input',
					nl: 'Controleer uw gegevens',
				})}
			</span>
		</button>
	);
};
